<template>
  <div class="user">
    <div class="head-page" v-if="isLogin">
      <div class="head-img"><img :src="detail.avatar || require('@/assets/default-avatar.svg')" alt=""></div>
      <div class="info">
        <div class="mobile">{{ detail.nickname || '已登录' }}</div>
        <div class="vip"><van-icon name="diamond-o" /> 普通会员 </div>
        <div class="sub">{{ detail.mobile ? '手机号：' + detail.mobile : '未绑定手机号' }}</div>
      </div>
      <!-- 个人资料入口：统一放在右上角「编辑资料」 -->
      <div class="edit-entry" @click="$router.push('/profile')"><van-icon name="edit" /><span>编辑资料</span></div>
    </div>
    <div class="head-page" v-else @click="$router.push('/login')">
      <div class="head-img"><img src="@/assets/default-avatar.svg" alt=""></div>
      <div class="info">
        <div class="mobile">未登录</div>
        <div class="words">点击登录账号</div>
      </div>
    </div>
    <div class="my-asset">
      <div class="asset-left">
        <div class="asset-left-item"><span>{{ detail.balance || 0 }}</span><span>账户余额</span></div>
        <div class="asset-left-item"><span>0</span><span>积分</span></div>
        <div class="asset-left-item"><span>0</span><span>优惠券</span></div>
      </div>
    </div>
    <div class="order-navbar">
      <div class="order-navbar-item" @click="$router.push('/myorder?dataType=all')"><van-icon name="balance-list-o" /><span>全部订单</span></div>
      <div class="order-navbar-item" @click="$router.push('/myorder?dataType=payment')"><van-icon name="clock-o" /><span>待支付</span></div>
      <div class="order-navbar-item" @click="$router.push('/myorder?dataType=delivery')"><van-icon name="logistics" /><span>待发货</span></div>
      <div class="order-navbar-item" @click="$router.push('/myorder?dataType=received')"><van-icon name="send-gift-o" /><span>待收货</span></div>
      <div class="order-navbar-item" @click="$router.push('/myorder?dataType=refund')"><van-icon name="refund-o" /><span>退款/售后</span></div>
    </div>
    <div class="service">
      <div class="title">我的服务</div>
      <div class="content">
        <!-- 使用 flex 列布局，让每个服务项占满一行 -->
        <div class="content-item" @click="$router.push('/chat')">
          <van-icon name="service-o" />
          <span>联系客服</span>
        </div>
        <div class="content-item" @click="$router.push('/address')">
          <van-icon name="records" />
          <span>收货地址</span>
        </div>
        <div class="content-item" @click="$router.push('/complaint')">
          <van-icon name="comment-o" />
          <span>投诉反馈</span>
        </div>
      </div>
    </div>
    <div class="logout-btn">
      <button v-if="isLogin" @click="$router.push('/logout')">退出登录</button>
    </div>
    <!-- 底部安全占位，防止内容被底部导航栏遮挡 -->
    <div class="bottom-safe-area"></div>
  </div>
</template>

<script>
import { getUserInfoDetail } from '@/api/user'
import { Toast } from 'vant'

export default {
  name: 'User',
  data () {
    return {
      detail: {}
    }
  },
  computed: {
    isLogin () {
      return !!this.$store.getters.token
    }
  },
  created () {
    if (this.isLogin) {
      this.getUserInfoDetail()
    }
  },
  methods: {
    async getUserInfoDetail () {
      const { data } = await getUserInfoDetail();
      this.detail = data;
      this.$store.commit('user/setUserInfo', { ...this.$store.state.user.userInfo, ...data })
    }
  }
}
</script>

<style lang="less" scoped>
.user {
  min-height: 100vh;
  background-color: #f7f7f7;
  padding-bottom: calc(50px + 20px);

  .head-page {
    height: 130px;
    background: url('https://img.yzcdn.cn/vant/bg-01.png') center/cover;
    display: flex;
    align-items: center;
    .head-img {
      width: 50px;
      height: 50px;
      border-radius: 50%;
      overflow: hidden;
      margin: 0 10px;
      img { width: 100%; height: 100%; object-fit: cover; }
    }
    .info {
      .mobile { margin-bottom: 5px; color: #c59a46; font-size: 18px; font-weight: 700; }
      .vip { display: inline-block; background-color: #3c3c3c; padding: 3px 5px; border-radius: 5px; color: #e0d3b6; font-size: 14px; .van-icon { font-weight: 700; color: #ffb632; } }
      .words { font-size: 14px; color: #c59a46; }
      .sub { margin-top: 4px; font-size: 13px; color: #8a7a52; }
    }
    // 右上角「编辑资料」入口（个人资料唯一入口）
    .edit-entry {
      margin-left: auto;
      margin-right: 12px;
      display: flex;
      align-items: center;
      padding: 6px 12px;
      border-radius: 16px;
      background: rgba(255, 255, 255, 0.72);
      font-size: 13px;
      color: #8a7a52;
      cursor: pointer;

      .van-icon { margin-right: 4px; font-size: 16px; color: #ff6b35; }

      &:active { background: rgba(255, 255, 255, 0.9); }
    }
  }
  .my-asset {
    display: flex;
    padding: 20px 0;
    font-size: 14px;
    background-color: #fff;
    .asset-left {
      display: flex;
      justify-content: space-evenly;
      flex: 3;
      .asset-left-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        span:first-child { margin-bottom: 5px; color: #ff6b35; font-size: 16px; }
      }
    }
  }
  .order-navbar {
    display: flex;
    padding: 15px 0;
    margin: 10px;
    font-size: 14px;
    background-color: #fff;
    border-radius: 5px;
    .order-navbar-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 20%;
      .van-icon { font-size: 24px; margin-bottom: 5px; }
    }
  }
  .service {
    font-size: 14px;
    background-color: #fff;
    border-radius: 5px;
    margin: 10px;
    .title { 
      height: 50px; 
      line-height: 50px; 
      padding: 0 15px; 
      font-size: 16px; 
      border-bottom: 1px solid #f5f5f5; 
    }
    .content {
      display: flex;
      flex-direction: column; /* 改为纵向排列，每个服务占一行 */
      padding: 5px 0;
      .content-item {
        display: flex;
        align-items: center;
        padding: 15px 20px;
        border-bottom: 1px solid #f5f5f5;
        cursor: pointer;
        &:last-child {
          border-bottom: none; /* 最后一个去掉分割线 */
        }
        .van-icon { 
          font-size: 22px; 
          margin-right: 15px; 
          color: #ff6b35; 
        }
        span { 
          font-size: 15px; 
          color: #333;
        }
      }
    }
  }
  .logout-btn {
    button {
      width: 60%;
      margin: 10px auto;
      display: block;
      font-size: 13px;
      color: #616161;
      border-radius: 9px;
      border: 1px solid #dcdcdc;
      padding: 7px 0;
      text-align: center;
      background-color: #fafafa;
    }
  }
  .bottom-safe-area {
    height: 1px;
    width: 100%;
  }
}

/* 修复 Dialog 可能被遮挡的问题 */
/deep/ .van-dialog {
  z-index: 2000 !important;
}
</style>